
import '../App.css';
import '../Css/Contact.css';

export default function ContactTiles() {


  return (
    <div id='contactContainer' className='section-border-top'>
        <div className='section-title'>Contact</div>
        <div className='HLContainer'><div className='big-line'></div></div>
      <div id='contact'>
      
        <div className='contactDiv'>
          <img className='contactIcon' alt='TéléphoneIcon' src='./images/icons/mobile-icon-purple.png'></img>
          <div className='contactTitle'>Téléphone</div>
          <div className='text'><a href='tel:+41783376052'>+41 78 337 60 52</a></div>
        </div>
        <div className='contactDiv'>
          <img className='contactIcon' alt='locationIcon' src='./images/icons/address-location-icon-purple.png'></img>
          <div className='contactTitle'>Ville</div>
          <div className='text'>Genève</div>
        </div>
        <div className='contactDiv'>
          <img className='contactIcon' alt='email' src='./images/icons/email-address-icon-purple.png'></img>
          <div className='contactTitle'>E-mail</div>
          <div className='contact-text-wrapper text'><a href='mailto: contact@astraya.ch'>contact@astraya.ch</a></div>
        </div> 
    </div>
  </div>
    
  );
}